<template>
  <div id="app" :class="['browser_' + browser]">
    <template v-if="!appOutDated">
      <Loader />
      <FixedInfo />
      <EmojiSetSprite />
      <SaveNameScreen v-if="!playerNameSaved" />
      <router-view v-else></router-view>
    </template>
    <UpdateRequired v-else/>
  </div>
</template>
<style lang="scss" src="@/assets/css/bingo.scss"></style>

<script>
import Loader from "./components/Loader.vue";
import EmojiSetSprite from "./components/svg/EmojiSetSprite";
import SaveNameScreen from "./components/SaveNameScreen.vue";
import UpdateRequired from "./components/UpdateRequired.vue";
import FixedInfo from "./components/FixedInfo.vue";
import store from "@/store";

export default {
  computed: {
    room: () => store.state.room,
    isSoundOn: () => store.state.sound.isSoundOn,
    appOutDated: () => store.state.appOutDated,
    browser: () => store.state.browser,
    playerNameSaved: () => store.state.player.playerNameSaved
  },
  components: {
    SaveNameScreen,
    Loader,
    FixedInfo,
    EmojiSetSprite,
    UpdateRequired
  },
  created: () => {
    store.dispatch("setPlayer");
    store.dispatch("setSoundFromLocalStorage");
  },watch:{
    isSoundOn(oldValue,newValue){
      store.dispatch('playSound','soundOn');
    }
  }
};
</script>
